<div class="dt-card">
  <table class="dt-table text-left">
    <thead class="dt-head">
      <tr class="dt-head-row">
        @for (col of columns; track col.key) {
          <th
            [style.width]="col.width"
            [class]="col.headerClass || ''"
            [ngClass]="{
              'text-left': !col.align || col.align === 'left',
              'text-center': col.align === 'center',
              'text-right': col.align === 'right'
            }"
            class="dt-head-cell"
          >
            <span>{{ col.label | translate }}</span>
          </th>
        }
      </tr>
    </thead>
    <tbody class="dt-body">
      @if (loading) {
        <tr class="w-full flex">
          <td [attr.colspan]="columns.length" class="w-full p-4 border-0">
            <app-skeleton-list [columns]="skeletonColumns" [rows]="skeletonRows"></app-skeleton-list>
          </td>
        </tr>
      } @else {
        @for (row of data; track $index) {
          <tr
            (click)="onRowClick(row, $event)"
            [class.cursor-pointer]="clickableRows"
            class="dt-row table-fade-in"
          >
            @for (col of columns; track col.key) {
              <td
                [style.width]="col.width"
                [class]="col.cellClass || ''"
                [class.truncate]="col.truncate !== false && !getCellTemplate(col.key)"
                [ngClass]="{
                  'text-left': !col.align || col.align === 'left',
                  'text-center': col.align === 'center',
                  'text-right': col.align === 'right'
                }"
                class="dt-cell"
              >
                @if (getCellTemplate(col.key); as template) {
                  <ng-container
                    *ngTemplateOutlet="template; context: { $implicit: row, row: row, col: col, index: $index }"
                  ></ng-container>
                } @else {
                  <span [title]="row[col.key] || ''">{{ row[col.key] }}</span>
                }
              </td>
            }
          </tr>
        } @empty {
          <tr class="w-full flex">
            <td [attr.colspan]="columns.length" class="w-full p-8 text-center border-0">
              <app-empty-state
                [title]="emptyTitle"
                [description]="emptyDescription"
                [icon]="emptyIcon"
                [actionLabel]="emptyActionLabel"
                [actionRouterLink]="emptyActionRouterLink"
                (action)="emptyAction.emit()"
              ></app-empty-state>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>

@if (showPagination && !loading && totalPages > 0) {
  <div class="px-6 pt-3 pb-5 bg-white">
    <app-pagination
      [currentPage]="currentPage"
      [totalPages]="totalPages"
      [lastPage]="lastPage"
      [firstPage]="firstPage"
      (pageChange)="pageChange.emit($event)"
    ></app-pagination>
  </div>
}
